// api/agent.ts
import axios from "axios";

export const eximiusChatUrl = "https://playground-services.eximius.ai";

const token = "0E10AE3C-CC13-4925-8278-4D3E9F5CBC1B"; // Directly set the token here

const api = axios.create({
  baseURL: "https://dev-services.eximius.ai", // Replace with your actual base URL
  headers: {
    Authorization: `Bearer ${token}`, // Pass token directly here in the Authorization header
  },
});

export const generateJobDescription = async (payload: any) => {
  const response = await api.post("/eximius/api/v2/enhancegeneratejd", payload);
  return response.data;
};

export const getMockCandidates = async (payload: any) => {
  const response = await api.post(
    "/eximius/api/mock_candidate_search",
    payload
  );
  return response.data.messageList || [];
};

export const getMockScoreCard = async (payload: any) => {
  const response = await api.post("/eximius/api/mock_scorecard", payload);
  return response.data.messageList || [];
};
export const getMockCandidateData = async (payload: any) => {
  const response = await api.post("/eximius/api/mock_get_candidate", payload);
  return response.data.messageList || [];
};

export const getProceedScreening = async (payload: any) => {
  const response = await api.post("/eximius/api/proceed_screening", payload);
  return response.data.message_list || [];
};
export const generate_otp = async (payload: any) => {
  const response = await api.post("/eximius/api/generate_otp", payload);
  return response.data.message_list || [];
};

export const verify_otp = async (payload: any) => {
  const response = await api.post("/eximius/api/verify_otp", payload);
  return response.data.message_list || [];
};

export const submit_feedback = async (payload: any) => {
  const response = await api.post("/eximius/api/submit_feedback", payload);
  return response.data;
};

export const bookDemo = async (payload: any) => {
  const response = await api.post("/eximius/api/send_email_book_demo", payload);
  return response.data;
};

export default api;
